module.exports = __webpack_public_path__ + "img/+.1a6aeeb9.svg";